import { getAuthHeader } from './getAuth';
import { isAU } from './byConfig';

export const generateUploadConfig = ({
  applicationRef,
  channel,
  documentSubType,
  handleDocUploadEvent,
  documentType,
  ...rests
}) => {
  const docUploadApiBaseUrl = import.meta.env.VITE_DOC_UPLOAD_API_URL;

  const setAuthorizationHeaderValue = () => {
    const authHeader = getAuthHeader();
    return authHeader;
  };

  return {
    ...rests,
    ...(docUploadApiBaseUrl ? { apiBaseUrl: docUploadApiBaseUrl } : {}),
    environment: import.meta.env.VITE_ENV === 'prod' ? 'production' : 'test',
    region: isAU() ? 'AU' : 'NZ',
    referenceType: 'APPLICATION_ID',
    reference: applicationRef,
    channel,
    clientId: isAU() ? 'ORIGINATIONS_AU' : 'ORIGINATIONS_NZ',
    businessUnit: 'LPAY',
    function: 'NEW_APPLICATION',
    documentType: documentType ?? 'PROOF_OF_INCOME',
    documentSubType,
    setAuthorizationHeaderValue,
    onEvent: handleDocUploadEvent,
  };
};
